export default (name) ->
	if !__ENV__? or __ENV__ isnt 'production'
		name
	else
		null
